var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTypeAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#16DEA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z",
    stroke: "#151515",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2399 15.7597C24.7978 16.3169 25.2404 16.9787 25.5423 17.707C25.8442 18.4354 25.9997 19.2162 25.9997 20.0047C25.9997 20.7932 25.8442 21.5739 25.5423 22.3023C25.2404 23.0307 24.7978 23.6924 24.2399 24.2497M15.7599 24.2397C15.2021 23.6824 14.7595 23.0207 14.4576 22.2923C14.1556 21.5639 14.0002 20.7832 14.0002 19.9947C14.0002 19.2062 14.1556 18.4254 14.4576 17.697C14.7595 16.9687 15.2021 16.3069 15.7599 15.7497M27.0699 12.9297C28.9446 14.805 29.9978 17.348 29.9978 19.9997C29.9978 22.6513 28.9446 25.1944 27.0699 27.0697M12.9299 27.0697C11.0552 25.1944 10.0021 22.6513 10.0021 19.9997C10.0021 17.348 11.0552 14.805 12.9299 12.9297",
    stroke: "#151515",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7599 15.7598C16.3172 15.202 16.9789 14.7594 17.7073 14.4575C18.4357 14.1555 19.2165 14.0001 20.0049 14.0001C20.7934 14.0001 21.5742 14.1555 22.3026 14.4575C23.031 14.7594 23.6927 15.202 24.2499 15.7598M12.9299 12.9298C14.8052 11.0551 17.3483 10.002 19.9999 10.002C22.6516 10.002 25.1947 11.0551 27.0699 12.9298",
    stroke: "#151515",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTypeAudio);
export default __webpack_public_path__ + "static/media/ic_type_audio.c8baf707.svg";
export { ForwardRef as ReactComponent };